import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { DataService } from '../services/data.service';
import { pushToArray, pushObjArray, pushToObject } from '../services/convert.service';
import { COLLECTION_NAME, APPS } from '../dummy/app';
import { ILevel } from '../interfaces/resource';
import { IDictionary } from '../interfaces/dictionary';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class DictionaryStore {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;
    uploads: any[];

    allPercentage: Observable<any>;
    picturePercentage: Observable<any>;
    soundPercentage: Observable<any>;
    files: Observable<any>;
    picUrl: any;
    soundUrl: any;
    constructor(
        private ds: DataService,
        private storage: AngularFireStorage,

    ) { }

    @action
    async fetchListArray(collectionName, orderBy) {
        const docs = await this.ds.listRef(collectionName, orderBy).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchCollection(collectionName, orderBy) {
        const docs = await this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).get().toPromise();
        return pushToArray(docs);
    }

    @action
    async fetchActivityType(key) {
        const docs = await this.ds.firestoreRef().collection(COLLECTION_NAME.ACTIVITY_TYPE).doc(key).get().toPromise();
        return pushToObject(docs);
    }

    @action
    fetchDataList(collectionName, orderBy, callback) {
        this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }


    @action
    fetchList(collectionName, orderBy, callback) {
        this.ds.listRef(collectionName, orderBy).valueChanges().subscribe(docs => {
            callback(docs)
        })
    }

    @action
    fetchActivityByModule(moduleKey, activityTypeKey, organizationKey, callback) {
        this.loading = true;
        this.ds.activityByModuleRef(moduleKey, activityTypeKey, organizationKey).valueChanges().subscribe(docs => {
            this.loading = false;
            callback(docs)
        })
    }

    @action
    async fetchActivity(moduleKey, displayStatus, organizationKey: string) {
        this.lastVisible = null;
        this.loading = true;
        this.ds.activityRef(this.lastVisible, moduleKey, displayStatus, organizationKey).valueChanges().subscribe(docs => {
            this.data = docs
            this.empty = docs.length === 0;
            this.loading = false;
            if (docs.length > 0 && docs.length >= APPS.SIZE) {
                this.lastVisible = docs[docs.length - 1];
            } else {
                this.lastVisible = null;
            }
        })
    }


    @action
    async fetchData(collectionName, displayStatus: any, organizationKey: string) {
        this.lastVisible = null;
        this.loading = true;
        const docs = pushToArray(await this.ds.resourceRef(collectionName, this.lastVisible, displayStatus, organizationKey).get().toPromise());
        this.data = docs
        this.empty = docs.length === 0;
        this.loading = false;
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
            this.lastVisible = docs[docs.length - 1];
        } else {
            this.lastVisible = null;
        }
    }

    @action
    async fetchMore(collectionName, displayStatus: any, organizationKey: string) {
        if (this.fetching || this.lastVisible === null || this.loading) { return; }
        this.fetching = true;
        const docsData = await this.ds.resourceRef(collectionName, this.lastVisible, displayStatus, organizationKey).get().toPromise();
        const docs = pushToArray(docsData);
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
            this.lastVisible = docs[docs.length - 1];
        } else {
            this.lastVisible = null;
        }
        this.data = this.data.slice().concat(docs);
        this.fetching = false;
    }

    @action
    fetchSelectedData(collectionName, key: any, callback) {
        this.ds.firestoreRef().collection(collectionName).doc(key).valueChanges().subscribe(doc => {
            callback(doc)
        })
    }

    @action
    addItem(collectionName, item: IDictionary, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.set(ref, item);
        batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    deleteFile(collection, filename) {
        // const ext = filename.split('.').pop()
        // const name = filename.split('.').slice(0, -1).join('.')
        const fileRef = this.storage.ref(collection + '/' + filename);
        fileRef.delete()
    }
    @action
    async addPOS(collectionName, header, detail, picture, callback) {
        this.process = true;

        // if (picture && oldPicture) {
        //     this.deleteFile(collectionName, oldPicture)
        // }
        // if (picture || sound) {

        this.process = true;
        this.uploads = [];
        const batch = this.ds.batch();

        const picturePercentage: Observable<number>[] = [];

        const picfilename = picture ? Math.random().toString(36).substring(7) + new Date().getTime() + picture.name : null;
        const picpath = `${collectionName}/${picfilename}`;
        const pictask = picture ? this.storage.upload(picpath, picture) : null;
        const _picpercentage$ = picture ? pictask.percentageChanges() : null;
        picturePercentage.push(_picpercentage$);

        const picuploadTrack = {
            pictureName: picfilename,
            percentage: _picpercentage$
        }
        this.uploads.push(picuploadTrack);

        this.picturePercentage = picture ? combineLatest(picturePercentage)
            .pipe(
                map((percentages) => {
                    let result = 0;
                    for (const percentage of percentages) {
                        result = result + percentage;
                    }
                    return result / percentages.length;
                }),
            ) : null;
        const _p = picture ? (await pictask.then(async (f) => {
            return await f.ref.getDownloadURL()
        })) : null;


        const { pos } = header;
        const data = {
            ...detail,
            pictureName: picture ? picfilename : null,
            pictureUrl: picture ? _p : null,
        }
        const items = pushObjArray(pos, data);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(header.key);
        batch.set(ref, {
            ...header,
            pos: items
        });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })

    }

    @action
    async addItemWithFile(isEdit, collectionName, items, picture, sound, oldPicture, oldSound, callback) {
        this.process = true;

        if (picture && oldPicture) {
            this.deleteFile(collectionName, oldPicture)
        }
        if (sound && oldSound) {
            this.deleteFile(collectionName, oldPicture)
        }

        // if (picture || sound) {
        this.process = true;
        this.uploads = [];
        const batch = this.ds.batch();

        const picturePercentage: Observable<number>[] = [];

        const picfilename = picture ? Math.random().toString(36).substring(7) + new Date().getTime() + picture.name : null;
        const picpath = `${collectionName}/${picfilename}`;
        const pictask = picture ? this.storage.upload(picpath, picture) : null;
        const _picpercentage$ = picture ? pictask.percentageChanges() : null;
        picturePercentage.push(_picpercentage$);

        const picuploadTrack = {
            pictureName: picfilename,
            percentage: _picpercentage$
        }
        this.uploads.push(picuploadTrack);

        this.picturePercentage = picture ? combineLatest(picturePercentage)
            .pipe(
                map((percentages) => {
                    let result = 0;
                    for (const percentage of percentages) {
                        result = result + percentage;
                    }
                    return result / percentages.length;
                }),
            ) : null;


        const soundPercentage: Observable<number>[] = [];
        const soundfilename = sound ? Math.random().toString(36).substring(7) + new Date().getTime() + sound.name : null;
        const soundpath = `${collectionName}/${soundfilename}`;
        const soundtask = sound ? this.storage.upload(soundpath, sound) : null;

        const _soundpercentage$ = sound ? soundtask.percentageChanges() : null;
        soundPercentage.push(_soundpercentage$);

        const sounduploadTrack = {
            pictureName: soundfilename,
            percentage: _soundpercentage$
        }
        this.uploads.push(sounduploadTrack);

        this.soundPercentage = sound ? combineLatest(soundPercentage)
            .pipe(
                map((percentages) => {
                    let result = 0;
                    for (const percentage of percentages) {
                        result = result + percentage;
                    }
                    return result / percentages.length;
                }),
            ) : null;

        const _s = sound ? (await soundtask.then(async (f) => {
            return f.ref.getDownloadURL()
        })) : null;
        const _p = picture ? (await pictask.then(async (f) => {
            return await f.ref.getDownloadURL()
        })) : null;

        const data = {
            ...items,
            pictureName: picture ? picfilename : items.pictureName,
            pictureUrl: picture ? _p : items.pictureUrl,
            soundName: sound ? soundfilename : items.soundName,
            soundUrl: sound ? _s : items.soundUrl,
        }
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(items.key);
        if (isEdit) {
            batch.update(ref, data);
        } else {
            batch.set(ref, data);
        }
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
        // }
    }


    @action
    delete(collectionName, item: ILevel, callback) {
        this.loading = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.delete(ref);
        batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(-1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.loading = false;
        })
    }

    @action
    async deleteModule(collectionModule, collectionActivity, item: ILevel, callback) {
        this.loading = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionModule).doc(item.key);
        const actRef = this.ds.batchCollectionRef().collection(collectionActivity);

        const docs = await this.ds.activityByModuleDBRef(item.key).get().toPromise();
        const data = pushToArray(docs);

        if (data && data.length > 0) {
            data.forEach(m => {
                batch.delete(actRef.doc(m.key))
            })
        }
        batch.delete(ref);
        batch.update(statisticRef, { [`${collectionModule}`]: firebase.firestore.FieldValue.increment(-1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.loading = false;
        })
    }

}
